import * as React from "react";
const SvgDelete = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#2D2D2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.111}
      d="M13.83 3.49a75 75 0 0 0-7.39-.368q-2.19 0-4.38.221l-1.505.148m4.056-.745.162-.966c.118-.7.207-1.224 1.453-1.224h1.932c1.247 0 1.343.553 1.453 1.231l.162.959m2.471 3.075-.48 7.427c-.08 1.158-.147 2.058-2.205 2.058H4.825c-2.058 0-2.124-.9-2.205-2.058l-.48-7.427m3.82 5.428h2.456M5.348 8.3h3.688"
    />
  </svg>
);
export default SvgDelete;
